<template>
    <div class="setSuccess">
        <h1 class="title">账户安全设置</h1>
        <div class="complete">
            <div>
                <p style="margin:0;">
                    <img src="../../assets/complete2.png" />
                </p>
                <p class="friendly-tips">您已完成当前安全设置</p>
                <p style="font-size:16px;color:#333333;margin-bottom:45px;">当前您的密码安全性低，就差一步就可以完成密码修改！</p>
            </div>
            <el-button type="info" plain @click="changeLater">稍后修改密码</el-button>
            <el-button type="primary" @click="changePassword">马上修改密码</el-button>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
        }
    },
    created () {
        if (sessionStorage.hasChecked !== 'info') {
            this.$router.push('/')
        } else {
            this.$ajax
                .post(
                    '/comuser-service/Account/finishCheck',
                    this.postData({
                        userId: sessionStorage.userUuid
                    })
                )
                .then(res => { })
        }
    },
    mounted () {
    },
    methods: {
        changeLater () {
            // this.$router.push('/trainClass/personalCenter/learnCenter/classSoftware')
            let OBJ = {
                '0': '/Err404',
                '1': '/EducationManagemant/trainClassManage',
                '2': '/trainClass/personalCenter/learnCenter/mockTest',
                '3': '/trainClass/personalCenter/learnCenter/mockTest',
            }
            sessionStorage.hasChecked = ''
            this.$router.push(OBJ[sessionStorage.btnsStatus])
            sessionStorage.loginSecond = 'second'
        },
        changePassword () {
            sessionStorage.hasChecked = 'setSuccess'
            this.$router.push('/SaftySetting/setPassword')
        }
    }
}
</script>
<style lang="scss">
.setSuccess {
  width: 1020px;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  .title {
    font-weight: normal;
    font-size: 24px;
    margin: 30px 40px;
    color: #333333;
    border-bottom:1px solid #eeeeee;
    padding-bottom: 20px;
  }
  .complete {
    text-align: center;
    img {
      margin: 50px 0 30px 0;
    }

    .el-button + .el-button {
      margin-left: 20px;
      background-color: #1060ab;
    }

    .friendly-tips {
      margin-left: 10px;
      font-size: 24px;
      margin: 0;
      margin-bottom: 20px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/saftySetting/setSuccess.vue